import React, { useState } from "react";
import tailwindClassnames from "./TailwindClassnames";
import { Icon } from "react-icons-kit";
import { eyeOff } from "react-icons-kit/feather/eyeOff";
import { eye } from "react-icons-kit/feather/eye";

type TextInputProps = {
  name: string;
  label: string;
  placeholder: string;
  value: string;
  error?: string;
  disabled: boolean;
  className: string;
  initialFocus?: boolean;
  limit?: number;
  onChange: (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => void;
  onKeyPress?: (event: React.KeyboardEvent<HTMLInputElement>) => void;
  onBlur?: (event: React.FocusEvent<HTMLInputElement>) => void;
};

const PasswordInput: React.FC<TextInputProps> = ({
  name,
  label,
  placeholder,
  value,
  error,
  disabled,
  className,
  initialFocus,
  limit,
  onChange,
  onKeyPress,
  onBlur,
}) => {
  const [type, setType] = useState("password");
  const [icon, setIcon] = useState(eyeOff);

  const handleToggle = () => {
    if (type === "password") {
      setIcon(eye);
      setType("text");
    } else {
      setIcon(eyeOff);
      setType("password");
    }
  };
  return (
    <div className="flex flex-col items-start">
      <label htmlFor={name} className={tailwindClassnames.textInputLabel}>
        {label}
      </label>
      <div className="flex w-full relative">
        <input
          id={name}
          maxLength={limit}
          name={name}
          type={type}
          placeholder={placeholder}
          value={value}
          disabled={disabled}
          className={className}
          autoFocus={initialFocus}
          onChange={onChange}
          onKeyUp={onKeyPress}
          onBlur={onBlur}
        />
        <span
          className="flex justify-around items-center"
          onClick={handleToggle}
        >
          <Icon className="absolute mr-10" icon={icon} size={25} />
        </span>
      </div>
      {error && (
        <p className="bg-primary-orange-light rounded text-primary-orange-dark text-sm px-3 py-2 my-1">
          {error}
        </p>
      )}
    </div>
  );
};

export default PasswordInput;
